var _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadroller(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M8.4,7c0,0.3-0.3,0.5-0.5,0.5l0,0C7.6,7.5,7.4,7.2,7.4,7V5.8c0-0.3,0.3-0.5,0.5-0.5l0,0 c0.3,0,0.5,0.3,0.5,0.5V7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2,14.2c0.4,0,0.7,0,1.1,0.2v-3.2H7.6V9.8H2.7L1,13.6v3.3h13.6C14.9,15.4,16.4,14.2,18.2,14.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 11.2,
    width: 5.1,
    height: 1.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "11.4,6.1 6.4,6.1 6.4,11.2 11.4,13.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11.1,13.4v1.1H10v-1.1H9.7v4.4h0.1H10h1.1h0.3v-0.3v-1.2V16v-1.2v-0.3v-1.1L11.1,13.4L11.1,13.4z M11.1,17.5 H10v-1.2h1.1V17.5z M11.1,16H10v-1.2h1.1V16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.6,
    style: {
      fill: "#000"
    },
    width: 1.4,
    height: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 6.6,
    style: {
      fill: "#000"
    },
    width: 2.1,
    height: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M9.4,12.7c0,0.4-0.3,0.6-0.6,0.6h-4c-0.4,0-0.6-0.3-0.6-0.6l0,0c0-0.4,0.3-0.6,0.6-0.6h4 C9.1,12,9.4,12.3,9.4,12.7L9.4,12.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M23,14.5c0,2.3-1.8,4.2-4.2,4.2s-4.2-1.8-4.2-4.2s1.8-4.2,4.2-4.2C21.2,10.3,23,12.1,23,14.5z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,14.5c0,0.9-0.7,1.7-1.7,1.7s-1.7-0.7-1.7-1.7s0.7-1.7,1.7-1.7S20.5,13.5,20.5,14.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.1,13.5c-1.4,0-2.6,1.1-2.6,2.6c0,1.4,1.1,2.6,2.6,2.6s2.6-1.1,2.6-2.6C6.6,14.6,5.5,13.5,4.1,13.5z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.7,16.1C5.7,17,5,17.8,4,17.8S2.4,17,2.4,16.1c0-0.9,0.7-1.7,1.7-1.7S5.7,15.2,5.7,16.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 4.1,
    cy: 16.1,
    r: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadroller);
export default __webpack_public_path__ + "static/media/roadroller.79f7639e5cd89197a7dedef8d6d904b1.svg";
export { ForwardRef as ReactComponent };